import { ItemType } from 'types';

// Constants for grid size and spacing
export const GRID_ROWS = 7;
export const GRID_COLS = 6;
export const CELL_SIZE = 60;

// Different item types and their sizes
export const ITEM_TYPES: ItemType = {
  MINOR: { width: 1, height: 1, color: '#BDB72C', name: 'Minor Idol' },
  TOTEMIC: { width: 1, height: 3, color: '#CD6155', name: 'Totemic Idol' },
  CONQUEROR: { width: 2, height: 2, color: '#E6B325', name: 'Conqueror Idol' },
  KAMASAN: { width: 1, height: 2, color: '#FF5733', name: 'Kamasan' },
  NOBLE: { width: 2, height: 1, color: '#33FF57', name: 'Noble' },
  BURIAL: { width: 3, height: 1, color: '#3357FF', name: 'Burial' },
  UNIQUE: { width: 1, height: 1, color: '#af6025', name: 'Unique' },
};

// Array of coordinates for disabled cells based on the screenshot pattern
export const DISABLED_CELLS: [number, number][] = [
  [0, 0], // Top-left corner
  [2, 1], [2, 4], // Center block in upper area
  [3, 1], [3, 2], [3, 3], [3, 4], // Horizontal line in middle
  [4, 1], [4, 4],// Below the horizontal line
  [6, 5] // Bottom horizontal line
];

// Local storage keys
export const STORAGE_KEYS = {
  PLACED_ITEMS: 'idolPlannerItems',
  STASH_ITEMS: 'idolStashItems'
};

// MapDevice consts

// Map options
export const MAPS = [
  "Any T16",
  "Any T16.5",
  "Any T17",
  "Abomination",
  "Academy",
  "Acid Caverns",
  "Alleyways",
  "Any Map",
  "Arachnid Nest",
  "Arachnid Tomb",
  "Arcade",
  "Arena",
  "Arid Lake",
  "Arsenal",
  "Ashen Wood",
  "Atoll",
  "Bazaar",
  "Beach",
  "Belfry",
  "Bone Crypt",
  "Bramble Valley",
  "Burial Chambers",
  "Canyon",
  "Castle Ruins",
  "Cells",
  "Cemetery",
  "Channel",
  "Chateau",
  "Citadel",
  "City Square",
  "Colosseum",
  "Core",
  "Courtyard",
  "Coves",
  "Crater",
  "Crimson Temple",
  "Crimson Township",
  "Cursed Crypt",
  "Dark Forest",
  "Defiled Cathedral",
  "Desert",
  "Desert Spring",
  "Dunes",
  "Estuary",
  "Excavation",
  "Factory",
  "Flooded Mine",
  "Forge of the Phoenix",
  "Forking River",
  "Fortress",
  "Frozen Cabins",
  "Ghetto",
  "Glacier",
  "Grave Trough",
  "Grotto",
  "Iceberg",
  "Infested Valley",
  "Ivory Temple",
  "Jungle Valley",
  "Lair of the Hydra",
  "Lava Chamber",
  "Lava Lake",
  "Lighthouse",
  "Lookout",
  "Marshes",
  "Mausoleum",
  "Maze",
  "Maze of the Minotaur",
  "Mesa",
  "Mineral Pools",
  "Moon Temple",
  "Mud Geyser",
  "Museum",
  "Necropolis",
  "Orchard",
  "Overgrown Shrine",
  "Palace",
  "Park",
  "Phantasmagoria",
  "Pit",
  "Pit of the Chimera",
  "Plateau",
  "Port",
  "Precinct",
  "Primordial Blocks",
  "Primordial Pool",
  "Promenade",
  "Racecourse",
  "Ramparts",
  "Residence",
  "Sanctuary",
  "Sepulchre",
  "Shipyard",
  "Shore",
  "Silo",
  "Spider Forest",
  "Strand",
  "Sulphur Vents",
  "Summit",
  "Temple",
  "Thicket",
  "Tower",
  "Toxic Sewer",
  "Tropical Island",
  "Underground River",
  "Underground Sea",
  "Vaal Pyramid",
  "Vaal Temple",
  "Villa",
  "Volcano",
  "Waste Pool",
  "Wasteland",
  "Waterways",
  "Ziggurat"
];

// Influence options
export const INFLUENCE_OPTIONS = [
  { id: 'maven', name: 'Maven', color: 'text-orange-500' },
  { id: 'searing_exarch', name: 'The Searing Exarch', color: 'text-red-500' },
  { id: 'eater_of_worlds', name: 'The Eater of Worlds', color: 'text-teal-500' },
];

// Map modifier options
export const ATLAS_MODS = [
  { id: 'default', name: 'Default', description: '(1 to 8)% increased Quantity of Items found in this Area' },
  { id: 'fortune', name: 'Fortune Favours the Brave', description: 'One of the options available from this device will be applied at random, including options you have not yet unlocked.' },
  { id: 'anarchy', name: 'Anarchy', description: 'Area contains 3 additional Rogue Exiles' },
  { id: 'torment', name: 'Torment', description: 'Area is haunted by 4 additional Tormented Spirits' },
  { id: 'domination', name: 'Domination', description: 'Area contains 4 additional Shrines' },
  { id: 'abyss', name: 'Abyss', description: 'Area contains 2 additional Abysses' },
  { id: 'ambush', name: 'Ambush', description: 'Area contains 4 additional Strongboxes' },
  { id: 'blight', name: 'Blight', description: 'Area contains a Blight Encounter' },
  { id: 'harbinger', name: 'Harbinger', description: 'Area contains 3 additional Harbingers' },
  { id: 'ritual', name: 'Ritual', description: 'Area contains a Ritual Encounter' },
  { id: 'beyond', name: 'Beyond', description: 'Slaying Enemies close together can attract monsters from Beyond this realm' },
  { id: 'heist', name: 'Heist', description: 'Area contains 3 additional Smuggler\'s Caches' },
  { id: 'legion', name: 'Legion', description: 'Area contains an additional Legion Encounter' },
  { id: 'ultimatum', name: 'Ultimatum', description: 'Area contains an Ultimatum Encounter' },
  { id: 'essence', name: 'Essence', description: 'Area contains 3 additional Imprisoned Monsters. Areas can contain Imprisoned Monsters' },
  { id: 'expedition', name: 'Expedition', description: 'Area contains an Expedition Encounter' },
  { id: 'harvest', name: 'Harvest', description: 'Area contains The Sacred Grove' },
  { id: 'delirium', name: 'Delirium', description: 'Area contains a Mirror of Delirium' },
  { id: 'settlers', name: 'Settlers', description: 'Area contains 2 additional Ore Deposits' },
  { id: 'imbued_abyss', name: 'Imbued Abyss', description: 'Area contains an additional Abyss. Abysses in Area have 100% increased chance to lead to an Abyssal Depths. Areas can contain Abysses' },
  { id: 'imbued_ambush', name: 'Imbued Ambush', description: 'Area contains 6 additional Strongboxes. 100% increased chance for Strongboxes in Area to be Unique' },
  { id: 'imbued_anarchy', name: 'Imbued Anarchy', description: 'Area is inhabited by 3 additional Rogue Exiles. Items dropped by Rogue Exiles in Area have a 20% chance to be Fractured' },
  { id: 'imbued_beyond', name: 'Imbued Beyond', description: 'Slaying Enemies close together can attract monsters from Beyond this realm. Monsters have 80% increased chance to spawn a Beyond Portal' },
  { id: 'imbued_blight', name: 'Imbued Blight', description: 'Area contains a Blight Encounter. Blight Chests in Area have a 100% increased chance to contain Oils' },
  { id: 'imbued_delirium', name: 'Imbued Delirium', description: 'Delirium Monsters in Area have 40% increased Pack Size. Areas contain a Mirror of Delirium' },
  { id: 'imbued_domination', name: 'Imbued Domination', description: 'Area contains 3 additional Shrines. 300% increased Duration of Shrine Effects on Players' },
  { id: 'imbued_essence', name: 'Imbued Essence', description: 'Imprisoned Monsters in Area have 30% chance to have 3 additional Essences. Area contains 2 additional Imprisoned Monsters' },
  { id: 'imbued_expedition', name: 'Imbued Expedition', description: 'Area contains an Expedition Encounter. Vendor Refresh Currencies dropped in Area have a 25% chance to be converted to Logbooks' },
  { id: 'imbued_harbinger', name: 'Imbued Harbinger', description: 'Area contains 3 additional Harbingers. Harbingers have a 25% chance to be replaced by a powerful Harbinger boss' },
  { id: 'imbued_harvest', name: 'Imbued Harvest', description: 'Area contains The Sacred Grove. Harvests in Area have 50% chance for the unchosen Crop to not wilt. Harvested Plants have 50% chance to spawn an additional Monster' },
  { id: 'imbued_heist', name: 'Imbued Heist', description: 'Area contains 5 additional Smuggler\'s Caches' },
  { id: 'imbued_legion', name: 'Imbued Legion', description: 'Area contains 2 additional Legion Encounters. Legion Encounters with a General in Area have both Generals' },
  { id: 'imbued_ritual', name: 'Imbued Ritual', description: 'Areas contain Ritual Altars. 150% increased chance of Ritual Altars with Special Rewards' },
  { id: 'imbued_torment', name: 'Imbued Torment', description: 'Area is haunted by 8 additional Tormented Spirits' },
  { id: 'imbued_ultimatum', name: 'Imbued Ultimatum', description: 'Areas contain an Ultimatum Encounter. Ultimatum Encounters in your Maps last up to 13 Rounds' },
];
